module.exports = __webpack_public_path__ + "static/img/img001.fbf9f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img001.png
// module id = +a5a
// module chunks = 1